import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveSecondaryCriteriaTemplate,
} from "@planzone/view-models";
import { SecondaryCriteriaIcon } from "@common/secondaryCriteriaIcon";
import { Props } from "./types";
import { TagIcon } from "./tagIcon";
import { RoleIcon } from "./roleIcon";

function ColumnIcon({ project, criteriaKey, className }: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { template: planzoneTemplate } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "resource",
  );
  const { template: projectTemplate } = useRetrieveSecondaryCriteriaTemplate(
    project.uuid,
    "resource",
  );
  const template = [...planzoneTemplate, ...projectTemplate];
  const iconMap = {
    tags: <TagIcon className={className} />,
    role: <RoleIcon className={className} />,
    text: <SecondaryCriteriaIcon type="text" className={className} />,
    date: <SecondaryCriteriaIcon type="date" className={className} />,
    number: <SecondaryCriteriaIcon type="number" className={className} />,
    list: <SecondaryCriteriaIcon type="list" className={className} />,
    document: <SecondaryCriteriaIcon type="document" className={className} />,
    link: <SecondaryCriteriaIcon type="link" className={className} />,
    resource: <SecondaryCriteriaIcon type="resource" className={className} />,
  };
  const criteria = template.find(({ uuid }) => uuid === criteriaKey);

  return (
    iconMap[(criteria ? criteria.type : criteriaKey) as keyof typeof iconMap] ||
    iconMap.text
  );
}

export { ColumnIcon };
